import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundSVG from 'assets/images/not-found.svg';

const NotFound = () => {
  return (
    <>
      <main>
        <div className="container">

          <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
            <h1>404</h1>
            <h2>The page you are looking for doesn&apos;t exist.</h2>
            <Link className="btn" to={'/LPO'}>Back to home</Link>
            <img src={NotFoundSVG} className="img-fluid py-5" alt="Page Not Found" style={{ width: 500, height: 500}} />
          </section>

        </div>
      </main>

      <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
    </>
  );
};

export default NotFound;
